(() => {
  const root = document.querySelector('[data-macrame-cookie-consent]');
  const storageKey = 'macrame-cookie-consent';
  let isBannerShown = false;

  if (!root) return;

  const main = root.querySelector('[data-macrame-cookie-main]');
  const preferences = root.querySelector('[data-macrame-cookie-preferences]');
  const settingsButton = root.querySelector('[data-macrame-cookie-settings]');
  const backButton = root.querySelector('[data-macrame-cookie-back]');
  const acceptButton = root.querySelector('[data-macrame-cookie-accept]');
  const necessaryButton = root.querySelector('[data-macrame-cookie-necessary]');

  const readStoredConsent = () => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  };

  const saveStoredConsent = (consent) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(consent));
    } catch (error) {
      // Shopify's Customer Privacy API remains the primary consent record when available.
    }
  };

  const close = () => {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('macrame-cookie-consent-open');
  };

  const showMain = () => {
    main.hidden = false;
    preferences.hidden = true;
    settingsButton.setAttribute('aria-expanded', 'false');
  };

  const showPreferences = () => {
    main.hidden = true;
    preferences.hidden = false;
    settingsButton.setAttribute('aria-expanded', 'true');
    preferences.querySelector('input:not([disabled])')?.focus();
  };

  const applyConsent = (privacy, consent) => {
    root.classList.add('is-saving');
    const finish = () => {
      saveStoredConsent(consent);
      close();
    };

    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      finish();
      return;
    }

    privacy.setTrackingConsent(consent, finish);
  };

  const showBanner = (privacy) => {
    if (isBannerShown) return;
    isBannerShown = true;

    const current = typeof privacy?.currentVisitorConsent === 'function' ? privacy.currentVisitorConsent() : {};
    const stored = readStoredConsent();
    root.querySelectorAll('[data-macrame-cookie-preference]').forEach((input) => {
      const preference = input.dataset.macrameCookiePreference;
      input.checked = current[preference] === 'yes' || stored?.[preference] === true;
    });

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('macrame-cookie-consent-open');

    acceptButton.addEventListener('click', () => {
      applyConsent(privacy, { analytics: true, marketing: true, preferences: true });
    });

    necessaryButton.addEventListener('click', () => {
      applyConsent(privacy, { analytics: false, marketing: false, preferences: false });
    });

    settingsButton.addEventListener('click', showPreferences);
    backButton.addEventListener('click', showMain);

    preferences.addEventListener('submit', (event) => {
      event.preventDefault();
      const selected = {};
      root.querySelectorAll('[data-macrame-cookie-preference]').forEach((input) => {
        selected[input.dataset.macrameCookiePreference] = input.checked;
      });
      applyConsent(privacy, selected);
    });
  };

  const showFallbackBanner = () => {
    if (!readStoredConsent()) showBanner(null);
  };

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    showFallbackBanner();
    return;
  }

  window.setTimeout(() => {
    const privacy = window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.shouldShowBanner !== 'function') showFallbackBanner();
  }, 1500);

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    const privacy = window.Shopify.customerPrivacy;
    if (error || !privacy || typeof privacy.shouldShowBanner !== 'function') {
      showFallbackBanner();
      return;
    }

    if (privacy.shouldShowBanner()) showBanner(privacy);
  });
})();
